<template>
  <div class="ec-line012" v-loading="loading">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <a :href="baseUrl">{{ this.shopName }}</a></el-breadcrumb-item
      >
      <el-breadcrumb-item :to="{ path: $routePage.EC_LINE009 }"> {{ $t('ec-line009.heading') }}</el-breadcrumb-item>
      <el-breadcrumb-item> {{ $t('ec-line012.title') }}</el-breadcrumb-item>
    </el-breadcrumb>
    <card-list
      v-if="!loading"
      :data="items"
      v-model="card_default"
      :submit="onSubmit"
      :cancel="onCancel"
      :submit-text="$t('ec-line012.updateDefaultCardBtn')"
      @to-detail="toEditCard"
    />

    <prompt-dialog
      :visible.sync="succesVisible"
      :title="$t('ec-line012.promptTitle')"
      :content="$t('ec-line012.promptContent')"
      @on-cancel="onCancel"
    />
  </div>
</template>

<script>
import { AuthService, MyPageService } from '@/services'
import BreadcrumbMixin from '@/mixins/breadcrumb'
import CardList from '@/components/ec-line012/CardList.vue'
import PromptDialog from '@/components/PromptDialog.vue'
import { CARD_DEFAULT_FLAG } from '@/constants'

export default {
  components: { CardList, PromptDialog },
  mixins: [BreadcrumbMixin],
  data() {
    return {
      loading: false,
      items: [],
      card_default: null,
      succesVisible: false,
    }
  },
  async created() {
    await this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true

      await MyPageService.getCardList({ customer_id: this.user.id })
        .then(({ data }) => {
          if (data) {
            this.items = data.reverse()
            this.card_default =
              this.items.find((i) => i.default_flag === CARD_DEFAULT_FLAG.DEFAULT)?.card_seq ||
              this.items[0]?.card_seq ||
              null
            if (this.card_default) {
              this.user.default_card_seq_num = this.card_default
            }
          }
        })
        .finally(() => (this.loading = false))
    },
    getCardInfo(val) {
      const cardInfo = this.items.find((item) => item.card_seq == val)
      const [, expiry_year, expiry_month] = cardInfo.expire.split(/(\d{2})(\d{2})/)
      return {
        gmo_id: this.user.gmo_id,
        holder_name: cardInfo.holder_name,
        expire: `${expiry_month}/${expiry_year}`,
        card_seq: cardInfo.card_seq,
        default_flag: cardInfo.default_flag,
      }
    },
    async onSubmit(default_card_seq_num) {
      this.loading = true

      const card_info =
        default_card_seq_num != this.card_default
          ? {
              before: {},
              after: this.getCardInfo(default_card_seq_num),
            }
          : undefined
      await AuthService.updateInfo(this.user.id, {
        name01: this.user.name01,
        customer_status: this.user.customer_status_id,
        email: this.user.email,
        pref_id: this.user.pref.id,
        default_card_seq_num,
        card_info,
      })
        .then(() => {
          this.succesVisible = true
        })
        .catch((error) => this.handleError(error))
        .finally(() => (this.loading = false))
      // .then(() => this.$alert({ message: this.$t('ec-line012.updateAdressSucces'), type: 'success' }))
    },
    onCancel() {
      this.$router.push(this.$routePage.EC_LINE009)
    },
    toEditCard(cardSeq) {
      this.$router.push(cardSeq ? { name: 'EC_LINE013_EDIT', params: { id: cardSeq } } : { name: 'EC_LINE013_NEW' })
    },
  },
  metaInfo() {
    return {
      title: this.$t('ec-line012.title'),
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$t('ec-line012.description', { shop_name: this.shopName }),
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$t('ec-line012.keyword', { shop_name: this.shopName }),
        },
      ],
    }
  },
}
</script>

<style></style>
